/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Bar } from "react-chartjs-2";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Draggable from "react-draggable";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Chart from "chart.js/auto";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Button, Paper } from "@mui/material";
import moment from "moment";
Chart.register(ChartDataLabels);
Chart.defaults.set("plugins.datalabels", {
  color: "#000",
  backgroundColor: "#ccc",
  formatter: function (value) {
    return value.toLocaleString();
  },
});
function PaperComponent(props) {
  return (
    <Draggable
      handle='#draggable-dialog-title'
      cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export default function BarChart({
  label,
  value,
  FilteredData,
  color,
  height,
}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const [labelName, setLabelName] = React.useState("");
  const handleClose = () => {
    setOpen(false);
    setLabelName("");
  };

  const [dataShow, setData] = React.useState([]);
  React.useEffect(() => {
    if (labelName !== "") {
      handleModal();
    }
  }, [labelName]);
  const desiredOrder = [
    "claim_code",
    "date",
    "branch",
    "category",
    "designation",
    "department",
    "description",
    "employee_name",
    "amount",
    "sanctioned_by",
    "approved_by",
    "attention_to",
  ];
  const columns = Object.keys(dataShow[0] || {})
    .filter((key) => key !== "_id")
    .sort((a, b) => {
      // Sort based on the desiredOrder array
      const orderA = desiredOrder.indexOf(a);
      const orderB = desiredOrder.indexOf(b);
      return (
        (orderA === -1 ? Infinity : orderA) -
        (orderB === -1 ? Infinity : orderB)
      );
    })
    .map((key) => ({
      field: key,
      headerName: key
        .replace(/_/g, " ")
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase()),
      minWidth: 170,
      align: "left",
    }));

  // Example usage:
  function handleModal() {
    // Step 1: Map over the data and format the date fields
    const formattedData = FilteredData.map((claim) => {
      return {
        ...claim,
        // Format the 'date' field if it exists and is valid
        date: moment(claim.date, moment.ISO_8601, true).isValid()
          ? moment(claim.date).format("DD-MM-YYYY")
          : claim.date, // If not a valid date, keep the original value
      };
    });

    // Step 2: Apply the filter on the formatted data
    const res = formattedData.filter((claim) => {
      const claimValues = Object.values(claim);

      return claimValues.some(
        (value) =>
          value && value.toString().toLowerCase() === labelName.toLowerCase()
      );
    });

    // Step 3: Set the filtered data and open the modal
    if (labelName.toLocaleLowerCase() === "imprest") {
      const data = res.filter(
        (d) => d.category.toLocaleLowerCase() === "imprest"
      );
      setData(data);
      handleClickOpen();
      return;
    }
    setData(res);
    handleClickOpen();
  }

  value.forEach((element) => {
    element.toFixed(2);
  });
  const data = {
    labels: label,
    datasets: [
      {
        fill: true,
        label: "Amount",
        data: value,
        borderColor: "#000000",
        backgroundColor: color ? color : "#3e5871",
        height: "100px",
        datalabels: {
          display: true,
          backgroundColor: "transparent",
        },
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        display: true,
        anchor: "end",
        align: "top",
        color: "#000",
        fontSize: { font: "14px" },
        font: {
          weight: "bold",
        },
      },
      legend: {
        display: false,
      },
      title: {
        display: true,

        text: "Amount",
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const clickedElementIndex = elements[0].index;
        const labelName = data.labels[clickedElementIndex];
        // const value = outstandings.datasets[0].data[clickedElementIndex];
        setLabelName(labelName.toLowerCase());
      }
    },
  };

  return (
    <div style={{ height: height ? height : "50vh", width: "100%" }}>
      <Bar data={data} options={options} />
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby='draggable-dialog-title'>
        <DialogTitle style={{ cursor: "move" }} id='draggable-dialog-title'>
          Data
        </DialogTitle>
        <DialogContent>
          <Paper>
            <DataGrid
              columns={columns}
              getRowId={(row) => row._id}
              rows={dataShow}
              slots={{ toolbar: GridToolbar }}
              style={{ height: "50vh" }}
              disableRowSelectionOnClick
            />
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
